/**
 * A custom icon button component.
 * Replaces MUI IconButton component.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.icon - Icon name to display
 * @param {Function} props.onClick - Click handler function
 * @param {boolean} [props.disabled=false] - Disabled state
 * @param {string} [props.color="black"] - Icon color
 * @param {string} [props.tooltip] - Tooltip text
 * @param {string} [props.className] - Additional CSS classes
 * @param {boolean} [props.loading=false] - Loading state
 * @param {Object} [props.style] - Additional inline styles
 * @returns {JSX.Element} A button with icon that shows tooltip on hover
 *
 * @author Forge
 * @date 2026-04-03
 * @version 1.0.0
 */

import Icon from "../Icon";
import CustomTooltip from "./CustomTooltip";

export default function CustomIconButton({
  icon,
  onClick,
  disabled = false,
  color = "black",
  tooltip = "",
  className = "",
  loading = false,
  style = {},
}) {
  const buttonContent = (
    <button
      className={`custom-icon-button ${className}`}
      onClick={onClick}
      disabled={disabled || loading}
      style={{ color, ...style }}
    >
      {loading ? (
        <div className="custom-icon-button-spinner"></div>
      ) : (
        <Icon name={icon} />
      )}
    </button>
  );

  if (tooltip) {
    return <CustomTooltip title={tooltip}>{buttonContent}</CustomTooltip>;
  }

  return buttonContent;
}
